import { render } from "./admin-email.svg?vue&type=template&id=419eef08"
const script = {}
script.render = render

export default script